import React from 'react';

let did = false;
const ensure = () => {
  if (did || typeof document === 'undefined') return;
  did = true;
  const s = document.createElement('style');
  s.dataset.pl = 'button';
  s.textContent = `
.pl-btn{display:inline-flex;align-items:center;justify-content:center;gap:var(--pl-s-3);
  min-height:var(--pl-control-h);padding:0 var(--pl-s-5);white-space:nowrap;cursor:pointer;
  font-family:var(--pl-font-sans);font-size:var(--pl-fs-body);font-weight:var(--pl-w-semi);
  line-height:1;text-decoration:none;border:var(--pl-border-w) solid transparent;
  border-radius:var(--pl-radius-1);
  transition:background var(--pl-dur-fast) var(--pl-ease),border-color var(--pl-dur-fast) var(--pl-ease),color var(--pl-dur-fast) var(--pl-ease)}
.pl-btn--sm{min-height:var(--pl-control-h-sm);padding:0 var(--pl-s-4);font-size:var(--pl-fs-small)}
.pl-btn--lg{min-height:var(--pl-control-h-site);padding:0 18px;font-size:15px}
.pl-btn--primary{background:var(--pl-primary);color:var(--pl-on-primary);border-color:var(--pl-primary)}
.pl-btn--primary:not(.pl-btn--sm):not(.pl-btn--lg){padding:0 14px}
.pl-btn--primary:hover:not(:disabled){background:var(--pl-primary-hover);border-color:var(--pl-primary-hover)}
.pl-btn--secondary{background:var(--pl-surface);color:var(--pl-ink);border-color:var(--pl-line-strong)}
.pl-btn--secondary:hover:not(:disabled){background:var(--pl-surface-sunk)}
.pl-btn--ghost{background:transparent;color:var(--pl-primary);border-color:transparent}
.pl-btn--ghost:hover:not(:disabled){background:var(--pl-primary-tint)}
.pl-btn--text{background:transparent;border-color:transparent;color:var(--pl-primary);
  padding:0;text-decoration:underline;text-underline-offset:3px}
.pl-btn--text:hover:not(:disabled){color:var(--pl-primary-hover)}
.pl-btn--danger{background:var(--pl-red-600);color:var(--pl-white);border-color:var(--pl-red-600)}
.pl-btn--danger:hover:not(:disabled){background:var(--pl-red-700);border-color:var(--pl-red-700)}
.pl-btn--full{width:100%}
.pl-btn:disabled{opacity:.45;cursor:not-allowed}
`;
  document.head.appendChild(s);
};

export const Button = React.forwardRef(function Button(
  { variant = 'primary', size = 'md', href, full = false,
    disabled = false, children, className = '', ...rest },
  ref,
) {
  ensure();
  const cls = ['pl-btn', 'pl-btn--' + variant,
               size === 'sm' ? 'pl-btn--sm' : size === 'lg' ? 'pl-btn--lg' : '',
               full ? 'pl-btn--full' : '', className].filter(Boolean).join(' ');
  if (href && !disabled) return <a ref={ref} className={cls} href={href} {...rest}>{children}</a>;
  return <button ref={ref} type="button" className={cls} disabled={disabled} {...rest}>{children}</button>;
});
